export const SET_VENDORS = "SET_VENDORS";
export const RESET_VENDORS = "RESET_VENDORS";
export const SET_SPECIFIC_VENDORS = "SET_SPECIFIC_VENDORS";
export const RESET_SPECIFIC_VENDORS = "RESET_SPECIFIC_VENDORS";
